"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeathCertificate = function DeathCertificate(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 512 512", className: "custom-icon" }, props),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "m132.757 444h268v-412h-32v-32h-184.485l-83.515 83.515v328.485h32zm236-400h20v388h-244v-20h224zm-188-23.515v59.515h-59.515zm-68 379.515v-308h80v-80h164v388z" }),
      _react2.default.createElement("path", { d: "m138.757 112h96v12h-96z" }),
      _react2.default.createElement("path", { d: "m138.757 144h96v12h-96z" }),
      _react2.default.createElement("path", { d: "m138.757 176h192v12h-192z" }),
      _react2.default.createElement("path", { d: "m138.757 208h192v12h-192z" }),
      _react2.default.createElement("path", { d: "m170.757 240h128v12h-128z" }),
      _react2.default.createElement("path", { d: "m272.757 310c0-20.953-17.047-38-38-38s-38 17.047-38 38v34h-16v36h108v-36h-16zm-64 0c0-14.336 11.664-26 26-26s26 11.664 26 26v34h-52zm68 46v12h-84v-12z" }),
      _react2.default.createElement("path", { d: "m240.757 296h-12v10h-10v12h10v18h12v-18h10v-12h-10z" }),
      _react2.default.createElement("path", { d: "m389.243 468h-288.486v44h288.485l22-22zm-48.486 32h-228v-20h228zm47.515-4-4 4h-31.515v-20h31.515l4 4h-25.515v12z" }),
      _react2.default.createElement("path", { d: "m254.757 156h76v-92h-76zm12-80h52v68h-52z" })
    )
  );
};

exports.default = DeathCertificate;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/deathcertificate.js
// module id = 1759
// module chunks = 895